module.exports = __webpack_public_path__ + "static/media/invitatie-custom-icon.59bd8faa.svg";